import { ADMIN_FAQ_LIST_GROUP } from './index';
import { Action } from '../action';
import { FaqGroupInfo } from '@shared/core';

export class AdminFaqListGroupInitAction implements Action {
	readonly type = ADMIN_FAQ_LIST_GROUP.INIT;
	constructor(
		public payload?: null,
		public correlationId?: number
	) {}
}

export class AdminFaqListGroupDestroyAction implements Action {
	readonly type = ADMIN_FAQ_LIST_GROUP.DESTROY;
	constructor(
		public payload?: null,
		public correlationId?: number
	) {}
}

export class AdminFaqListGroupClickShowQuestionsAction implements Action {
	readonly type = ADMIN_FAQ_LIST_GROUP.CLICK_SHOW_QUESTIONS;
	constructor(
		public payload?: null,
		public correlationId?: number
	) {}
}

export class AdminFaqListGroupClickAddAction implements Action {
	readonly type = ADMIN_FAQ_LIST_GROUP.CLICK_ADD;
	constructor(
		public payload?: null,
		public correlationId?: number
	) {}
}

export class AdminFaqListGroupClickAddGroupAction implements Action {
	readonly type = ADMIN_FAQ_LIST_GROUP.CLICK_ADD_GROUP;
	constructor(
		public payload?: null,
		public correlationId?: number
	) {}
}

export class AdminFaqListGroupClickEditAction implements Action {
	readonly type = ADMIN_FAQ_LIST_GROUP.CLICK_EDIT;
	constructor(
		public payload: FaqGroupInfo,
		public correlationId?: number
	) {}
}

export class AdminFaqListGroupClickDeleteAction implements Action {
	readonly type = ADMIN_FAQ_LIST_GROUP.CLICK_DELETE;
	constructor(
		public payload: FaqGroupInfo,
		public correlationId?: number
	) {}
}

export class AdminFaqListGroupClickDeleteSuccessAction implements Action {
	readonly type = ADMIN_FAQ_LIST_GROUP.CLICK_DELETE_SUCCESS;
	constructor(
		public payload: FaqGroupInfo,
		public correlationId?: number
	) {}
}

export class AdminFaqListGroupClickDeleteFailureAction implements Action {
	readonly type = ADMIN_FAQ_LIST_GROUP.CLICK_DELETE_FAILURE;
	constructor(
		public payload: any,
		public correlationId?: number
	) {}
}

export class AdminFaqListGroupHydrateAction implements Action {
	readonly type = ADMIN_FAQ_LIST_GROUP.HYDRATE;
	constructor(
		public payload?: null,
		public correlationId?: number
	) {}
}

export class AdminFaqListGroupHydrateSuccessAction implements Action {
	readonly type = ADMIN_FAQ_LIST_GROUP.HYDRATE_SUCCESS;
	constructor(
		public payload: FaqGroupInfo[],
		public correlationId?: number
	) {}
}

export class AdminFaqListGroupHydrateFailureAction implements Action {
	readonly type = ADMIN_FAQ_LIST_GROUP.HYDRATE_FAILURE;
	constructor(
		public payload: any,
		public correlationId?: number
	) {}
}
